<template>
  <section class="app-main">
    <!--    消息-->
    <transition name="el-fade-in-linear" v-if="!isCloseMsg&&isMsg">
      <div class="msg" :class="sidebar.opened?'':'hideSidebar'">
        <div class="content">
          <i class="el-icon-warning"></i> 您目前有{{ msgNum }}个缴费提醒！<span @click="btnHandle">去处理</span>
        </div>
        <div class="btnClose" @click="btnCloseMsg">
          <i class="el-icon-error"></i>
        </div>
      </div>
    </transition>
    <!--    悬浮框-->
    <transition name="el-zoom-in-bottom">
      <el-button :icon="isQuick?'el-icon-download':'el-icon-upload2'" type="primary" class="btnQuick" @click="btnQuick"
                 circle title="点击我显示快捷方式"></el-button>
    </transition>
    <transition name="el-zoom-in-bottom" v-if="isQuick">
      <div class="suspensionFrame">
        <div class="item" @click="btnQQ">
          <svg-icon icon-class="qq" class-name='quick'/>
          <span>QQ</span>
        </div>
        <div class="item">
          <div @click="btnDownload">
            <svg-icon icon-class="weixin" class-name='quick'/>
            <span>下载</span>
          </div>
          <transition name="el-fade-in-linear" v-if="isDownload">
            <div class="downloadCode">
              <div class="code-item">
                <el-image :src="appCode?(appCode.indexOf('http')>=0?appCode:prefixImgUrl+appCode):''"></el-image>
                <span>APP下载</span>
              </div>
              <div class="code-item">
                <el-image :src="wxCode?(wxCode.indexOf('http')>=0?wxCode:prefixImgUrl+wxCode):''"></el-image>
                <span>微信公众号</span>
              </div>
            </div>
          </transition>
        </div>
        <div class="item">
          <div @click="btnService">
            <svg-icon icon-class="service" class-name='quick'/>
            <span>咨询</span>
          </div>
          <transition name="el-fade-in-linear" v-if="isService">
            <div class="servicePane">
              <div class="service-item">
                <p>业务咨询</p>
                <p>{{ information }}</p>
              </div>
              <div class="service-item">
                <p>客服咨询</p>
                <p>{{ phone }}</p>
              </div>
            </div>
          </transition>
        </div>
        <div class="item" @click="btnTop">
          <svg-icon icon-class="top" class-name='quick'/>
          <span>顶部</span>
        </div>
      </div>
    </transition>
    <!--    需要局部缓存的界面-->
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="keepAliceRouters">
        <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" v-if="!$route.meta.keepAlive
      "></router-view>
    </transition>

  </section>
</template>

<script>
import {homeRemindCount} from "@/api/home";
import {floatingDetail} from "@/api/system/floating";
import {mapGetters} from "vuex";
import {keepAliceWriteRouters} from "@/utils/globalVariable";

export default {
  name: 'AppMain',
  components: {
  },
  data() {
    return {
      isCloseMsg: false,//是否关闭消息弹出框
      isQuick: false,//是否显示快捷方式
      isMsg: false,//是否显示消息弹出框
      msgNum: 0, //消息条数
      isDownload: false,
      isService: false,
      QQ: "", //qq
      appCode: '',
      wxCode: "",
      information: "",//业务咨询
      phone: "",//客服联系电话
      prefixImgUrl: sessionStorage.getItem('prefixImgUrl')
    }
  },
  computed: {
    keepAliceRouters() { //缓存白名单
      return keepAliceWriteRouters
    },
    ...mapGetters(['sidebar']),
    key() {
      this.msg();
      this.getFloating();
      return this.$route.path;
    },
  },

  methods: {
    //查询缴费提醒数量
    msg() {
      homeRemindCount().then(res => {
        if (res) {
          this.msgNum = Number(res.data.count)
          this.isMsg = Number(res.data.count) > 0;
        }
      })
    },
    //获取侧边栏信息
    getFloating() {
      floatingDetail().then(res => {
        if (res) {
          this.QQ = res.data.customerQQ;
          this.appCode = res.data.appQrCode;
          this.wxCode = res.data.wxQrCode;
          this.information = res.data.information
          this.phone = res.data.phone;
        }
      })
    },
    btnHandle() {
      this.$router.push({name: "renew"})
    },
    //关闭消息
    btnCloseMsg() {
      this.isMsg = false;
      this.isCloseMsg = true
    },
    //是否显示快捷方式
    btnQuick() {
      this.getFloating();
      this.isQuick = !this.isQuick;
      this.isDownload = false;
      this.isService = false;
    },
    //回到顶部
    btnTop() {
      var timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let isPeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + isPeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30)
    },
    //qq
    btnQQ() {
      this.getFloating()
      window.open('tencent://message/?Menu=yes&uin=' + this.QQ + '&Site=80fans&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a545b1714f9d45', '_self');
    },
    //下载
    btnDownload() {
      this.getFloating();
      this.isDownload = !this.isDownload;
      this.isService = false;
    },
    //咨询
    btnService() {
      this.getFloating();
      this.isDownload = false;
      this.isService = !this.isService
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

/*消息处理*/
.msg {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 50px;
  width: calc(100% - 250px);
  z-index: 9;
  height: 60px;
  text-align: center;
}
.msg.hideSidebar{
  width: calc(100% - 54px)
}
.msg .content {
  text-align: center;
  background: #fff;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: 300px;
  border-radius: 5px;
  margin: 10px auto;
}

.msg i {
  color: #FAAD14
}

.msg span {
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 20px;
}

.msg .btnClose {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  cursor: pointer;
}

.msg .btnClose i {
  color: #fff
}

/*悬浮框*/
.suspensionFrame {
  position: fixed;
  right: 10px;
  width: 50px;
  border-radius: 5px;
  background: #fff;
  z-index: 8;
  bottom: 100px;
  box-shadow: 0 2px 12px 0 rgba(0 0 0 0.1);
  border: 1px solid #ebeef5;
  padding: 20px 0;
}

.suspensionFrame .item {
  height: 60px;
  text-align: center;
  cursor: pointer;
  margin: 8px auto;
}

/deep/ .suspensionFrame .item .quick {
  display: block;
  width: 30px !important;
  height: 30px !important;
  margin: auto;
  color: #656D92;
}

.suspensionFrame span {
  display: block;
  margin-top: 5px;
}

.suspensionFrame .downloadCode {
  position: absolute;
  right: 60px;
  top: 70px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0 0 0 0.1);
  border: 1px solid #ebeef5;
}

.suspensionFrame .downloadCode .code-item {
  width: 80px
}

.suspensionFrame .downloadCode .code-item .el-image {
  width: 50px;
  height: 50px
}

.suspensionFrame .downloadCode .code-item span {
  font-size: 12px
}

.suspensionFrame .servicePane {
  position: absolute;
  right: 60px;
  top: 140px;
  background: #fff;
  padding: 0 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0 0 0 0.1);
  border: 1px solid #ebeef5;
}

.suspensionFrame .service-item {
  margin: 10px
}

.suspensionFrame .service-item p {
  margin: 2px auto
}

.btnQuick {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 9;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

</style>
